import { useEffect, useState } from 'react';

const FUSO = 'America/Sao_Paulo';

const partes = (data) => {
  const fmt = new Intl.DateTimeFormat('pt-BR', {
    timeZone: FUSO,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });
  const p = Object.fromEntries(fmt.formatToParts(data).map(({ type, value }) => [type, value]));
  const dataExtenso = new Intl.DateTimeFormat('pt-BR', {
    timeZone: FUSO, weekday: 'long', day: 'numeric', month: 'long',
  }).format(data);
  return {
    horas: p.hour,
    minutos: p.minute,
    segundos: p.second,
    dataExtenso,
    horaDecimal: Number(p.hour) + Number(p.minute) / 60,
  };
};

// Hora oficial de Brasília, independente do fuso do computador. Atualiza na
// virada de cada segundo (alinhado ao relógio, sem acumular atraso).
export default function useHoraBrasilia() {
  const [agora, setAgora] = useState(() => partes(new Date()));

  useEffect(() => {
    let timeout;
    const tick = () => {
      setAgora(partes(new Date()));
      timeout = setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    timeout = setTimeout(tick, 1000 - (Date.now() % 1000));
    return () => clearTimeout(timeout);
  }, []);

  return agora;
}

// Fase do céu conforme a hora de Brasília.
export const faseDoCeu = (horaDecimal) => {
  if (horaDecimal >= 5 && horaDecimal < 7) return 'amanhecer';
  if (horaDecimal >= 7 && horaDecimal < 17) return 'dia';
  if (horaDecimal >= 17 && horaDecimal < 19) return 'entardecer';
  if (horaDecimal >= 19 || horaDecimal < 1) return 'noite';
  return 'madrugada';
};
